module.exports = __webpack_public_path__ + "../resources/images/newsletters-c754a28922b5104dfb26dfce6fe83e30.svg";